import { getApolloClient } from '../lib/getApolloClient';
import { GET_TIMESHEETS_FOR_APPROVAL } from './timesheetApproval.gql';
import {
  TimesheetApprovalPage,
  TimesheetApprovalView,
} from './timesheetApproval.types';

const getTimesheetsForApproval = async (
  tenantId: string,
  view: TimesheetApprovalView,
  clientId?: string,
  limit?: number,
  lastEvaluatedKey?: string,
): Promise<TimesheetApprovalPage> => {
  const { data } = await getApolloClient().query<{
    getTimesheetsForApproval: TimesheetApprovalPage;
  }>({
    query: GET_TIMESHEETS_FOR_APPROVAL,
    variables: {
      tenantId,
      view,
      ...(clientId && { clientId }),
      ...(limit && { limit }),
      ...(lastEvaluatedKey && { lastEvaluatedKey }),
    },
    fetchPolicy: 'network-only',
  });
  const page = data.getTimesheetsForApproval;
  return {
    items: page?.items ?? [],
    hasMore: page?.hasMore ?? false,
    lastEvaluatedKey: page?.lastEvaluatedKey ?? null,
  };
};

export const timesheetApprovalActions = {
  getTimesheetsForApproval,
};
